export default {
  label: 'Mystery Settings',
  name: 'mystery',
  component: 'group',
  fields: [
    {
      label: 'Mystery Items',
      name: 'items',
      component: 'textarea',
      description:
        'Enter the handles of the products that should be considered mystery items, separated by commas',
      defaultValue: 'mystery-item',
      rows: 10,
    },
  ],
};
